import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../../config/backend';
import './HistoricoTimeline.css';

const EVENT_TYPES = {
    TICKET: 'ticket',
    ASSIGNMENT: 'assignment',
    MAINTENANCE: 'maintenance',
    NOTE: 'note'
};

function getEventType(deshis) {
    const text = (deshis || '').toString().toLowerCase().trim();
    if (/abertura\s+de\s+chamado|chamado\s*[-–]\s*\d+|\d+\s*[-–]\s*chamado/.test(text)) return EVENT_TYPES.TICKET;
    if (/vincul(ação|ado|o)|atribui(ção|do)|usuário\s+atribuído|desvincul/.test(text)) return EVENT_TYPES.ASSIGNMENT;
    if (/manutenção|manutencao|reparo|documentar\s+(manutenção|manutencao)/.test(text)) return EVENT_TYPES.MAINTENANCE;
    return EVENT_TYPES.NOTE;
}

function getTicketIdFromText(deshis) {
    const text = (deshis || '').toString().trim();
    const match = text.match(/(?:abertura\s+de\s+chamado|chamado)\s*[-–]\s*(\d+)/i) || text.match(/[-–]\s*(\d+)(?:\s|$|\n)/);
    return match ? parseInt(match[1], 10) : null;
}

function formatHistoryDate(d) {
    if (!d) return '—';
    const dt = new Date(d);
    return dt.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}

function EventText({ deshis, ticketId }) {
    const text = (deshis || '').toString();
    if (!ticketId) return <span className="historico-timeline__text-inner">{text || '—'}</span>;

    const numStr = String(ticketId);
    const idx = text.indexOf(numStr);
    if (idx === -1) return <span className="historico-timeline__text-inner">{text || '—'}</span>;

    const before = text.slice(0, idx);
    const after = text.slice(idx + numStr.length);
    return (
        <span className="historico-timeline__text-inner">
            {before}
            <Link to={`/historicoSati/${ticketId}`} className="historico-timeline__ticket-link">
                Chamado #{ticketId}
            </Link>
            {after}
        </span>
    );
}

function EventIcon({ type }) {
    const iconByType = {
        [EVENT_TYPES.TICKET]: 'fa-ticket-alt',
        [EVENT_TYPES.ASSIGNMENT]: 'fa-user-check',
        [EVENT_TYPES.MAINTENANCE]: 'fa-wrench',
        [EVENT_TYPES.NOTE]: 'fa-sticky-note'
    };
    const icon = iconByType[type] || 'fa-circle';
    return <i className={`fas ${icon} historico-timeline__icon`} aria-hidden="true" />;
}

function HistoricoTimeline({ arrayHistoricoHardware = [], onDeleted }) {
    const deleteHistorico = async (seqHis, e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!window.confirm('Excluir este registro do histórico?')) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.delete(ensureProtocol(localStorage.getItem('ipBackend2')) + '/hishardware', {
                headers: { Authorization: `${token}` },
                data: { seqHis }
            });
            if (typeof onDeleted === 'function') onDeleted();
        } catch (err) {
            console.error(err);
            alert('Erro ao excluir.');
        }
    };

    if (arrayHistoricoHardware.length === 0) {
        return (
            <p className="historico-timeline__empty">Nenhum registro no histórico.</p>
        );
    }

    return (
        <ul className="historico-timeline">
            {arrayHistoricoHardware.map((item, index) => {
                const eventType = getEventType(item.deshis);
                const ticketId = getTicketIdFromText(item.deshis);
                return (
                    <li
                        key={item.seqhis ?? index}
                        className={`historico-timeline__item historico-timeline__item--${eventType}`}
                    >
                        <span className="historico-timeline__dot" aria-hidden="true" />
                        <div className="historico-timeline__content">
                            <div className="historico-timeline__head">
                                <div className="historico-timeline__meta">
                                    <EventIcon type={eventType} />
                                    <time className="historico-timeline__date" dateTime={item.dathis || undefined}>
                                        {formatHistoryDate(item.dathis)}
                                    </time>
                                    {eventType === EVENT_TYPES.TICKET && ticketId != null && (
                                        <span className="historico-timeline__ticket-label">Chamado relacionado</span>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    className="historico-timeline__delete"
                                    onClick={(e) => deleteHistorico(item.seqhis, e)}
                                    title="Excluir registro"
                                    aria-label="Excluir registro"
                                >
                                    <i className="fas fa-trash" />
                                </button>
                            </div>
                            <p className="historico-timeline__text">
                                <EventText deshis={item.deshis} ticketId={ticketId} />
                            </p>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}

export default HistoricoTimeline;
